import { types, actions } from './requests'
export const DELETETURN_TYPES = {
    ...types('DELETETURN'),
}
export const DELETETURN_ACTIONS = {
    ...actions('DELETETURN'),
}
